import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-cell" }

import { ref } from 'vue'
import type { TableColumnCtx, TableInstance } from 'element-plus'

interface User {
  date: string
  name: string
  address: string
  tag: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FundList',
  setup(__props) {

const tableRef = ref<TableInstance>()

const resetDateFilter = () => {
  tableRef.value!.clearFilter(['date'])
}
const clearFilter = () => {
  tableRef.value!.clearFilter()
}
// eslint-disable-next-line no-unused-vars
const formatter = (row: User, column: TableColumnCtx<User>) => {
  return row.address
}
const filterTag = (value: bigint, row: User) => {
  return row.tag.length > value
}
const filterHandler = (
    value: string,
    row: User,
    column: TableColumnCtx<User>
) => {
  const property = column['property']
  return row[property] === value
}

const tableData: User[] = [
  {
    date: '2016-05-03',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
    tag: 'Home',
  },
  {
    date: '2016-05-02',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
    tag: 'Office',
  },
  {
    date: '2016-05-04',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
    tag: 'Home',
  },
  {
    date: '2016-05-01',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
    tag: 'Office',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, { onClick: resetDateFilter }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("reset date filter", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_el_button, { onClick: clearFilter }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("reset all filters", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      ref_key: "tableRef",
      ref: tableRef,
      "row-key": "date",
      data: tableData,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: "Date",
          sortable: "",
          width: "180",
          "column-key": "date",
          filters: [
        { text: '2016-05-01', value: '2016-05-01' },
        { text: '2016-05-02', value: '2016-05-02' },
        { text: '2016-05-03', value: '2016-05-03' },
        { text: '2016-05-04', value: '2016-05-04' },
      ],
          "filter-method": filterHandler
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "address",
          label: "Address",
          formatter: formatter
        }),
        _createVNode(_component_el_table_column, {
          prop: "tag",
          label: "Tag",
          width: "100",
          filters: [
        { text: '>3', value: 3 },
        { text: '>5', value: 5 },],
          "filter-method": filterTag,
          "filter-placement": "bottom-end"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.tag === 'Home' ? 'primary' : 'success',
              "disable-transitions": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.tag), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "custom-cell" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(scope.row.date), 1),
              _createElementVNode("span", null, _toDisplayString(scope.row.name), 1),
              _createElementVNode("span", null, _toDisplayString(scope.row.address), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})